const styles = {
  root: {
    height: { xs: 'unset', sm: 'calc(100vh - 89px)' },
    overflowY: 'scroll',
    // backgroundColor: 'red',
    '&.default, .MuiPaper-root': {
      backgroundColor: 'unset',
    },
    '&.variant': {
      height: 'unset!important',
      paddingBottom: '0px!important',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },

  },

  filterItem: {
    borderBottom: 1,
    borderColor: '#E9E9E9',

    '.MuiButtonBase-root': {
      borderRadius: '0!important',
      ':hover': {
        borderRadius: '0!important',
      },
    },
  },
  filterItemYear: {
    '.MuiButtonBase-root': {
      borderRadius: '0!important',
      ':hover': {
        borderRadius: '0!important',
      },
    },
  },

  accordionSummary: {
    '&.dialog': {},
  },

  title: {
    '&.MuiTypography-h2': {
      color: 'text.primaryDark',
    },
  },

  listItem: {
    px: 0,
  },

  filterContainer: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.main',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    py: 1,
    px: 2,
    backgroundColor: 'rgba(32,193,231, 0.05)',
  },

  dialog: {
    '& .MuiDialog-paper': {
      padding: 0,
      paddingTop: 4,
      overflowY: 'hidden',
    },
  },

  filtersDialogTitle: {
    padding: 2,
    borderBottom: 1,
    borderColor: 'divider',
  },

  filtersDialogContent: {
    height: 'fill-available',
    overflow: 'auto',
  },

  applyFilters: {
    backgroundColor: (theme) => `${theme.palette.highlight.main}!important`,
    color: 'white',
    margin: '0 auto',
    paddingX: 2,
    marginBottom: 1,
    whiteSpace: 'nowrap',
    marginTop: 2,
  },

  arrowDown: {
    color: 'text.primaryDark',
  },

  easyBanner: {
    padding: 1,
    backgroundColor: 'background.primaryEasy',
    borderRadius: 0.5,
  },

  easyBannerText: {
    '&.MuiTypography-root': {
      color: (theme) => `${theme.palette.text.white}!important`,
    },
  },
}

export default styles
